var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('user-layout-vue',[_c('h2',{staticClass:"user__title"},[_vm._v("내가 쓴 글")]),_c('div',{staticClass:"userinput__container"},_vm._l((_vm.feeds),function(feed){return _c('TheFeedCardVue',{key:feed.id,attrs:{"feed":feed}})}),1)])],1)}
var staticRenderFns = []

export { render, staticRenderFns }